import { Block, BlockContainer } from '../atoms';
import { SimpleTable, SimpleTableRow } from '../molecules';
import { FormattedAddress } from '../../common/utils/formatters';
import { useAccountStore } from '../../contexts';

const AccountOverview = () => {
  const merchantDetails = useAccountStore((state) => state.merchantDetails);

  if (!merchantDetails) {
    // Technically unreachable
    return null;
  }

  return (
    <>
      <BlockContainer>
        <Block size="half">
          <h2>Basic Details</h2>
          <SimpleTable>
            <SimpleTableRow
              title="Merchant Encoded Key"
              contentType="text"
              content={merchantDetails.merchantEncodedKey || ''}
            />
            <SimpleTableRow
              title="Account Name"
              contentType="text"
              content={merchantDetails.accountName}
            />
            <SimpleTableRow
              title="Trading Name"
              contentType="text"
              content={merchantDetails.tradingName || ''}
            />
            <SimpleTableRow
              title="Account Holder"
              contentType="text"
              content={merchantDetails.accountOwner || ''}
            />
            <SimpleTableRow
              title="Account Status"
              contentType="text"
              content={merchantDetails.accountStatus || ''}
            />
            <SimpleTableRow
              title="ABN"
              contentType="text"
              content={merchantDetails.abn || ''}
            />
            <SimpleTableRow
              title="RTO Number"
              contentType="text"
              content={merchantDetails.rtoNumber || ''}
            />
            <SimpleTableRow
              title="Accreditation Date"
              contentType="date"
              content={merchantDetails.accreditationDate || ''}
            />
            <SimpleTableRow
              title="Accreditation Review Date"
              contentType="date"
              content={merchantDetails.accreditationReviewDate || ''}
            />
            <SimpleTableRow
              title="Type"
              contentType="text"
              content={merchantDetails.type || ''}
            />
            <SimpleTableRow
              title="Zepto Contact ID"
              contentType="text"
              content={merchantDetails.zeptoContactId || ''}
            />
          </SimpleTable>
        </Block>
        <Block size="half">
          <h2>Main Contact Details</h2>
          <SimpleTable>
            <SimpleTableRow
              title="First Name"
              contentType="text"
              content={merchantDetails.merchantContact?.contactFirstName || ''}
            />
            <SimpleTableRow
              title="Last Name"
              contentType="text"
              content={merchantDetails.merchantContact?.contactLastName || ''}
            />
            <SimpleTableRow
              title="Email"
              contentType="text"
              content={merchantDetails.merchantContact?.contactEmail || ''}
            />
            <SimpleTableRow
              title="Phone"
              contentType="text"
              content={merchantDetails.merchantContact?.contactPhone || ''}
            />
            <SimpleTableRow
              title="Website"
              contentType="text"
              content={merchantDetails.website || ''}
              breakAll={true}
            />
            <SimpleTableRow
              title="Address"
              contentType="text"
              content={
                <FormattedAddress address={merchantDetails.shippingAddress} />
              }
            />
            <SimpleTableRow
              title="Billing Address"
              contentType="text"
              content={
                <FormattedAddress address={merchantDetails.billingAddress} />
              }
            />
          </SimpleTable>
        </Block>
      </BlockContainer>
    </>
  );
};

export { AccountOverview };
